module.exports = __webpack_public_path__ + "media/images/wallet/payment3-f28315cf241fc3615018c3874be9b219.svg";